"use strict";
import { FeatureFlags } from "features/gating/flags";
import { useFeatureFlag } from "features/gating/hooks";
import { useHasAccountMismatchCallback } from "features/smartWallet/mismatch/hooks";
import { useEvent } from "utilities/src/react/hooks";
export function useGetGeneratePermitAsTransaction() {
  const forceTrue = useFeatureFlag(FeatureFlags.ForcePermitTransactions);
  const mismatchUXEnabled = useFeatureFlag(FeatureFlags.EnablePermitMismatchUX);
  const getHasMismatch = useHasAccountMismatchCallback();
  return useEvent((chainId) => {
    return forceTrue || getHasMismatch(chainId) && mismatchUXEnabled;
  });
}
